import React, {ReactNode} from 'react';
import {FluidObject} from 'gatsby-image';
import Img from 'gatsby-image';
import {BlogEmbeddedAssetCaption} from './BlogEmbddedAsset.styles';

export interface BlogEmbeddedAssetProps {
  fluid: FluidObject;
  alt: string;
  description: string;
}

export const BlogEmbeddedAsset: React.FunctionComponent<BlogEmbeddedAssetProps> = (
  props
) => {
  return (
    <div>
      <Img fluid={props.fluid} alt={props.alt} />
      <BlogEmbeddedAssetCaption>
        {props.description.toUpperCase()}
      </BlogEmbeddedAssetCaption>
    </div>
  );
};
